// extracted by mini-css-extract-plugin
export var parcelRow = "_uy-0";